import { updateItemInCollection } from "directus/src/operations";

export async function updateResults({ item, caseStudyId }) {
    try {
        const query = {
            fields: [
                "id",
                "solution_overview",
                "obstacles",
                "methodology",
                "achievements",
            ],
        };

        const data = await updateItemInCollection(
            "case_studies",
            caseStudyId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
